import React, { Component } from 'react';
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import PanelGroupController from "../../components/PanelGroupController";
import ConsignmentList from "./List";
import PropertiesPanel from "./PropertiesPanel";
import ActionButton from "../../components/ActionButton";
import {fromJS, List, Map} from "immutable";
import SearchQueriesPanel from "../../components/panels/SearchQueriesPanel";
import FilterPanel from '../../components/panels/FilterPanel';
import {connect} from 'react-redux';
import {requestConsignmentCommand, requestConsignmentDetails} from '../../actions/ConsignmentApiActions';


// Filter options used in the right hand panel
const statusFilterOptions = fromJS([
  {id: "", label: "All"},
  {id: "started", label: "Started"},
  {id: "completed", label: "Completed"},
]);

const searchOptions = fromJS([
  {prop: "trackingNumber", label: "Tracking Number", type: "string"},
  {prop: "recipientName", label: "Recipient Name", type: "string"},
])

class ConsignmentTrackingPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.state = {
      id: "",
      hasSelection: false,
      currentConsignmentAndActivities: null,
      selectedPanelId: "general",
      statusFilter: "started",
    }
  }

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = `Consignments for warehouse "${this.getWarehouseId()}"`;

    return (
      <div className="ConsignmentsTrackingsPage">;
        <AppSidebar />
        <PageHeader title={title} />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton
              label="Mark Consignment"
              active={this.state.hasSelection}
              onClick={() => this.handleExecuteCommand(this.state.currentConsignmentAndActivities, false)} />
            <ActionButton
              label="Report Consignment"
              active={this.state.hasSelection}
              onClick={() => this.handleExecuteCommand(this.state.currentConsignmentAndActivities, true)} />
          </PanelGroupController>
        </div>
      </div>
    )
  }

  renderView(page) {
    const searchQueries = Map(this.props.router.location.query);
    // tracking in the url is not a filter but the warehouse information for the dashboard
    const uriFilters = searchQueries.delete("tracking").toJS()

    return (
      <ConsignmentList
        warehouseId={this.getWarehouseId()}
        selectedId={this.state.id}
        onSelectionChange={this.handleSetSelection}
        statusFilter={this.state.statusFilter}
        filters={uriFilters}
        onDetailsCommand={this.handleDetailsCommand.bind(this)}
        />
    )
  }

  getWarehouseId() {
    return this.props.location.query?.tracking;
  }

  renderPanels(page) {
    return this.state.selectedPanelId === "general"
      ? this.buildPanels(List(["statusFilter", SearchQueriesPanel, PropertiesPanel]))
      : this.buildPanels(List([]));
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case PropertiesPanel:
        return <PropertiesPanel
                key="ConsignmentsTrackingPropertiesPanel"
                expanded={true}
                id={this.state.id}
                hasSelection={this.state.hasSelection}
                consignmentAndActivities={this.state.currentConsignmentAndActivities}
                />
      case "statusFilter":
        return <FilterPanel
          key="filterPanel"
          title="Consignments Filter"
          expanded={true}
          options={statusFilterOptions}
          onClick={this.handleSetStatusFilter.bind(this)}
          filter={this.state.statusFilter}
          />
      case SearchQueriesPanel:
        return <SearchQueriesPanel
                key="SearchQueriesPanel"
                expanded={true}
                properties={searchOptions}
                query={Map(this.props.router.location.query)}
                onChange={this.handleSearchParamChange.bind(this)}
                onClear={this.handleSearchClear.bind(this)}
                />
      default:
        return null;      
    }
  }

  handleSearchParamChange(prop, value) {
    let searchQueries = Map(this.props.router.location.query)
    if (value === "") {
      searchQueries = searchQueries.delete(prop)
    } else {
      searchQueries = searchQueries.set(prop, value);
    }
    this.props.router.push({
      pathname: "/",
      query: searchQueries.toJS()
    });
  }

  handleSearchClear() {
    let searchQueries = Map(this.props.router.location.query);
    let searchOptionKeys = searchOptions.map((val) => val.get("prop"));
    let emptySearchQueries = searchOptionKeys.reduce((acc, key) => {
      return acc.delete(key);
    }, searchQueries);

    this.props.router.push({
      pathname: "/",
      query: emptySearchQueries.toJS()
    });
  }

  handleSetSelection(id, consignmentAndActivities) {
    this.setState({id: id, hasSelection: true, currentConsignmentAndActivities: consignmentAndActivities});
  }

  handleSetStatusFilter(item) {
    this.setState({
      statusFilter: item.get("id")
    });
  }

  handleExecuteCommand(consignmentAndActivities, report) {
    this.props.requestConsignmentCommand(consignmentAndActivities, report)
  }

  handleDetailsCommand(consignmentAndActivities) {
    this.props.requestConsignmentDetails(consignmentAndActivities)
  }
}


const mapDispatchToProps = dispatch => ({
  requestConsignmentCommand: (consignment, report) => {
    dispatch(requestConsignmentCommand(consignment, report));
  },
  requestConsignmentDetails: (consignment) => {
    dispatch(requestConsignmentDetails(consignment));
  },
})


export default connect(null, mapDispatchToProps)(ConsignmentTrackingPage);
